module.exports = __webpack_public_path__ + "src/assets/images/accident-management/icon-spanner-orange.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/accident-management/icon-spanner-orange.jpg
// module id = 2312
// module chunks = 4